<script>
import { VueEditor } from 'vue2-editor'
export default {
  name: 'Editor',
  components: {
    VueEditor,
  },
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      customToolbar: [['bold', 'italic', 'underline'], ['clean']],
    }
  },
  computed: {
    editorContent: {
      get() {
        return this.content
      },
      set(updatedContent) {
        this.$emit('update:content', updatedContent)
      },
    },
  },
}
</script>
<template>
  <div class="editor-wrapper">
    <VueEditor
      v-model="editorContent"
      :editor-toolbar="customToolbar"
    ></VueEditor>
  </div>
</template>
<style lang="scss" module>
@import '@design';
</style>
